import { render, staticRenderFns } from "./Thrifter.vue?vue&type=template&id=b4df84a6&scoped=true&"
import script from "./Thrifter.vue?vue&type=script&lang=js&"
export * from "./Thrifter.vue?vue&type=script&lang=js&"
import style0 from "./Thrifter.vue?vue&type=style&index=0&id=b4df84a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4df84a6",
  null
  
)

export default component.exports